import { jsx as _jsx } from "react/jsx-runtime";
import { Button as MUIButton, styled } from '@mui/material';
import { CheckCircleOutline, ThumbUpOutline } from 'mdi-material-ui';
const ApproveMockupButton = ({ approved = false, setStatus, }) => {
    const Button = styled(MUIButton)(({ theme }) => ({
        borderRadius: '4px',
        fontWeight: 400,
        maxWidth: '165px',
        color: approved ? '#22A06B' : '#6E60C4',
        borderColor: approved ? '#22A06B' : '#6E60C4',
        padding: '4px 12px',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
            borderColor: approved ? '#22A06B' : '#6E60C4',
        },
    }));
    return (_jsx(Button, Object.assign({ variant: "outlined", size: "small", startIcon: approved ? (_jsx(CheckCircleOutline, { sx: {
                color: '#22A06B',
                fontSize: '16px',
            } })) : (_jsx(ThumbUpOutline, { sx: {
                color: '#6E60C4',
                fontSize: '16px',
            } })), sx: {}, onClick: () => {
            if (!approved)
                setStatus();
        } }, { children: approved ? 'Mockup Approved' : 'Approve Mockup' })));
};
export default ApproveMockupButton;
